import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, ShoppingBag } from 'lucide-react';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-20 pb-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full text-center"
      >
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 200 }}>
          <XCircle size={64} className="mx-auto text-black/20 mb-6" />
        </motion.div>

        <h1 className="text-3xl font-syncopate font-bold tracking-tighter mb-2">Payment Cancelled</h1>
        <p className="text-sm text-black/40 mb-8">
          Your payment was cancelled. No charges were made. Your cart items are still saved.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/checkout')}
            className="flex items-center justify-center gap-2 w-full py-3.5 bg-black text-white text-[10px] font-bold uppercase tracking-[0.2em] rounded-xl hover:opacity-90 transition-opacity"
          >
            <ArrowLeft size={14} /> Back to Checkout
          </button>
          <button
            onClick={() => navigate('/shop')}
            className="flex items-center justify-center gap-2 w-full py-3.5 border border-black/10 text-[10px] font-bold uppercase tracking-[0.2em] rounded-xl hover:border-black/30 transition-colors"
          >
            <ShoppingBag size={14} /> Continue Shopping
          </button>
        </div>

        {orderId && (
          <p className="mt-6 text-[9px] text-black/20 uppercase tracking-wider">
            Order ref: {orderId.slice(0, 8)}
          </p>
        )}
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
